import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import i18n from 'i18n-js';
import styles from '../../style/scanpack';
import CommonStyles from '../../style/commonStyles';
import globalStyles from '../../style/global';
import DefaultInput from '../../commons/Inputs/defaultInput';

// The Z3 stop-and-receive ask/answer round trip — same visual shape as WmsLotVerificationPrompt
// (this component's L2/L3 sibling), reused deliberately per the brief's "copy, don't invent"
// convention. One structural addition: a "Pass" bypass affordance, which is ONLY EVER rendered
// when the caller passes `canBypass={true}` — that flag comes straight from the server's
// `receiving.can_bypass` (permissive mode only) via scanpackScanningActions' wmsZeroPending state,
// never inferred here. This same component renders all three chained Z3 steps (escalation code,
// lot, quantity) — see ScanPackPrompts.js's wms_zero_* renderers, which is the serial_scan /
// serial_scan_second chained-prompt pattern.
const WmsZeroInventoryPrompt = ({
  message,
  input,
  onChangeInput,
  onSubmit,
  onCancel,
  error,
  canBypass = false,
  onBypass,
  isSubmitting = false,
  testID = 'wmsZeroInventoryPrompt'
}) => {
  // See the sibling guard in WmsLotVerificationPrompt. The bypass button is guarded too: it
  // commits a Z3 pass, which is exactly the kind of action that must not fire twice.
  const handleSubmit = () => {
    if (isSubmitting) return;
    onSubmit();
  };

  const handleBypass = () => {
    if (isSubmitting) return;
    onBypass();
  };

  return (
    <View style={styles.typeScanContainer} dataSet={{ componentName: 'wmsZeroInventory' }} testID={testID}>
      <View style={{ width: '60%' }}>
        {error ? (
          <LinearGradient
            testID="wmsZeroInventoryErrorBanner"
            locations={[0, 1]}
            colors={['rgb(207,68,55)', 'rgb(122,40,40)']}
            style={CommonStyles.gradientContainer}
          >
            <View style={globalStyles.flexDirectionRow}>
              <Text style={[styles.scanCountText, { color: '#ffff', marginLeft: 5 }]}>
                {typeof error === 'string' ? error : ''}
              </Text>
            </View>
          </LinearGradient>
        ) : null}

        <LinearGradient
          testID="wmsZeroInventoryContainer"
          locations={[0, 1]}
          start={{ x: 0, y: 1 }}
          end={{ x: 0, y: 0 }}
          colors={['#d47d02', '#ffb636']}
          style={CommonStyles.gradientContainerOne}
        >
          <View style={globalStyles.flexDirectionRow}>
            <Text style={[styles.scanCountText, { marginLeft: '5%', marginTop: '2%' }]}>
              {message}
            </Text>
          </View>
          <View style={{ alignItems: 'center', justifyContent: 'center', width: '100%' }}>
            <View style={{ alignItems: 'center', width: '80%' }}>
              <DefaultInput
                testID="wmsZeroInventoryInput"
                value={input}
                onChangeText={onChangeInput}
                autoFocus={true}
                onSubmitEditing={handleSubmit}
                style={styles.scanCountTextInput}
              />
            </View>
            <View style={{ flexDirection: 'row' }}>
              <TouchableOpacity
                testID="wmsZeroInventoryCancel"
                style={[styles.scanCountButton, { marginLeft: '-50%' }]}
                onPress={onCancel}
              >
                <Text>Cancel</Text>
              </TouchableOpacity>
              {canBypass ? (
                <TouchableOpacity
                  testID="wmsZeroInventoryBypass"
                  style={styles.scanCountButton}
                  onPress={handleBypass}
                  disabled={isSubmitting}
                >
                  <Text>{i18n.t('wmsZeroInventory.passButton')}</Text>
                </TouchableOpacity>
              ) : null}
              <TouchableOpacity
                testID="wmsZeroInventorySubmit"
                style={[styles.scanCountButton, { marginLeft: '100%' }]}
                onPress={handleSubmit}
                disabled={isSubmitting}
              >
                <Text>Enter</Text>
              </TouchableOpacity>
            </View>
          </View>
        </LinearGradient>
      </View>
    </View>
  );
};

export default WmsZeroInventoryPrompt;
